module.exports = __webpack_public_path__ + "img/image21.f179856a.png";